import React, { useState, useEffect } from 'react';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import { SandhillsSlickSlider } from '@Components/Shared/SandhillsSlickSlider';
import EmbeddedYouTubeVideoThumbnail from '@Components/Shared/EmbeddedYouTubeVideoThumbnail';
import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';
import { gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import { gtmEventType } from '@Components/Utilities/SandhillsConstants';


const HostedSolutionsView = (props) => {
    const sliderSettings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 15000,
        responsive: null,
        infinite: true
    };

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const toggleModal = () => setModalIsOpen(modalIsOpen => !modalIsOpen);
    const FeedbackModal = loadable(() => import('@Components/Shared/Modals/FeedbackModal'), true);

    return (

        <div className="hosted-solutions-container">
            <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
            <div>
                <h1 className="page-heading">{props.H1Header}</h1>
                <p className="page-subheading">{props.PageSubheader}</p>
            </div>
            <div className="image-section">
                <div className="section-text">
                    <h2>{props.WebsitePlatformHeader}</h2>
                    <div className="section-subheading" dangerouslySetInnerHTML={{ __html: props.WebsitePlatformText }} />
                </div>
                <div className="section-image">
                    <img src={props.WebsitePlatformImageUrl} alt="Website Platform Image" />
                </div>
            </div>
            <div className="slider-section">
                <h2 className="section-heading">{props.WhyChooseHeader}</h2>
                {(props.HostedSolutionsCards && props.HostedSolutionsCards.length > 0) &&
                    <div className='slideshow'>
                        <ul className='cycle-slideshow'>
                            <SandhillsSlickSlider settings={sliderSettings} {...props}>
                                {props.HostedSolutionsCards.map((card, index) =>
                                    <li key={index}>
                                        <div className="Container">
                                            <div className="slide-image">
                                                <img src={card.ImageUrl} alt={card.AltText} />
                                            </div>
                                            <div className="slide-text">
                                                <h3>{card.ImageTitle}</h3>
                                                <div className="slide-bullets" dangerouslySetInnerHTML={{ __html: card.ImageParagraph }}/>
                                            </div>
                                        </div>
                                    </li>)}
                            </SandhillsSlickSlider>
                        </ul>
                    </div>}
            </div>
            <div className="image-section makes-us-different-section">
                <div className="section-text">
                    <h2>{translator.translate("sandhills.tradesites.mvc.whatmakesusdifferent")}</h2>
                    <p className="section-subheading">{props.WhatMakesUsDifferentSubheader}</p>
                    <div className="styled-list">
                        <ol>
                            <li>
                                <h3>{props.CustomizationText}</h3>
                                <p>{props.CustomizationTextCaption}</p>
                            </li>
                            <li>
                                <h3>{props.ExpertiseText}</h3>
                                <p>{props.ExpertiseTextCaption}</p>
                            </li>
                            <li>
                                <h3>{translator.translate("sandhills.tradesites.mvc.amorepowerfulplatform")}</h3>
                                <p>{props.PowerfulPlatformCaption}</p>
                            </li>
                            <li>
                                <h3>{translator.translate("sandhills.tradesites.mvc.seamlesstransitionwithnodowntime")}</h3>
                                <p>{props.SeamlessTransitionCaption}</p>
                            </li>
                            <li>
                                <h3>{translator.translate("sandhills.tradesites.mvc.contractfreeflexibility")}</h3>
                                <p>{props.NoContractCaption}</p>
                            </li>
                        </ol>
                    </div>
                </div>
                <div className="section-image">
                    <img src={props.WireframeImageUrl} alt="Website Platform Image" />
                </div>
            </div>
            <div className="video-section">
                <div className="video-section-text">
                    <h2 className="section-header">{translator.translate("sandhills.tradesites.mvc.whatourcustomersaresaying")}</h2>
                    <h3 className="section-subheader">{props.VideoSectionSubheader}</h3>
                    <p>{props.VideoSectionCaption}</p>
                </div>
                <div className="hosted-solutions-video">
                    <EmbeddedYouTubeVideoThumbnail
                        descriptionText={translator.translate("sandhills.tradesites.mvc.hereswhattheyhavetosay")}
                        altText={translator.translate("sandhills.tradesites.mvc.hereswhattheyhavetosay")}
                        videoId={props.WhatCustomersAreSayingVideoID}
                        onOpen={() => gtmPushEvent(gtmEventType.youtube_thumbnail, 'videoName', "HostedSolutionsView_WhatCustomersAreSaying")}
                    />
                </div>
            </div>
            <div className="request-section">
                <h2>{translator.translate("sandhills.tradesites.mvc.readytobuildcustomwebsite")}</h2>
                <div className="request-section-text" dangerouslySetInnerHTML={{ __html: props.RequestSectionText }} />
                <button className="ts-button" onClick={toggleModal}>{translator.translate("sandhills.tradesites.mvc.requestafreewebsiteconsultation")}</button>
                <div className="request-section-list">
                    <ul>
                        <li>{translator.translate("sandhills.tradesites.mvc.nocontracts")}</li>
                        <li>{translator.translate("sandhills.tradesites.mvc.nodowntime")}</li>
                        <li>{translator.translate("sandhills.tradesites.mvc.noobligation")}</li>
                    </ul>
                </div>
            </div>
            {modalIsOpen &&
                <FeedbackModal
                    {...props}
                    toggleModal={toggleModal}
                    title={translator.translate('Sandhills.TradeSites.MVC.FeedbackEmail')}
                />}
        </div>

    )}

export default HostedSolutionsView;
global.HostedSolutionsView = HostedSolutionsView;